import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

// ✅ IMPORT HEADER FOOTER
import TopHeader from "../../Header/TopHeader";
import Navbar from "../../Header/Navbar";
import Footer from "../../Footer/Footer";

function Propitorship() {

  const location = useLocation();
  const serviceId = location.state?.id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // ======================
  // API CALL
  // ======================
  const getServiceDetails = async () => {
    try {
      const res = await axios.get(
        `https://api.compliancekare.com/api/Compliance/ServiceDetailList?BusinessId=${serviceId}`
      );

      console.log("API RESPONSE:", res.data);

      const result = res?.data?.id || null;

      setData(result);

    } catch (error) {
      console.error("API ERROR:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (serviceId) getServiceDetails();
  }, [serviceId]);

  return (
    <>
      {/* ✅ HEADER */}
      <TopHeader />
      <Navbar />

      {/* ✅ MAIN CONTENT */}
      <div className="container mt-4">

        

        {loading ? (
          <p>Loading...</p>
        ) : data ? (
          <div className="card p-3 shadow">

            <h3>{data.serviceName}</h3>

            <div
              dangerouslySetInnerHTML={{
                __html: data.proprietorshipDescription || ""
              }}
            />

          </div>
        ) : (
          <p>No Data Found</p>
        )}

      </div>

      {/* ✅ FOOTER */}
      <Footer />
    </>
  );
}

export default Propitorship;